import { makeStyles } from "@material-ui/core/styles";

const useWTMPageStyles = makeStyles((theme) => ({
  breadcrumb: {
    marginTop: 5,
    marginBottom: 10,
  },
  grid: {
    minWidth: 800,
    minHeight: 700,
    position: "relative",
  },
  cardContent: {
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[50],
    borderBottomColor: theme.palette.grey[200],
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
    padding: theme.spacing(2),
  },
  cardNav: {
    padding: "1em",
  },
  loader: {
    left: "50%",
    position: "absolute",
    top: "50%",
    transform: "translateX(-50%) translateY(-50%)",
  },
  navigation: {
    paddingTop: 12,
  },
  pageTitle: {
    paddingTop: 12,
  },
  tabNav: {
    background: theme.palette.grey["500"],
  },
}));

export default useWTMPageStyles;
